import { ChangesTab } from '@/features/events/components/Detail/Tabs/ChangesTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/changes')({
  component: ChangesTab,
});
